/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentEnergyPriceResponse } from '../../models/current-energy-price-response';

export interface GetCurrentConsumptionPrice$Params {
  location_id: string;
}

export function getCurrentConsumptionPrice(http: HttpClient, rootUrl: string, params: GetCurrentConsumptionPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentEnergyPriceResponse>> {
  const rb = new RequestBuilder(rootUrl, getCurrentConsumptionPrice.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentEnergyPriceResponse>;
    })
  );
}

getCurrentConsumptionPrice.PATH = '/locations/{location_id}/consumption-price-current';
